var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sidecart_empty" }, [
    _c("div", { domProps: { innerHTML: _vm._s(_vm.messageOutput) } }),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "sidecart_empty_buttons" },
      _vm._l(_vm.buttonBlocks, function (block, i) {
        return _c("li", {
          key: i,
          domProps: { innerHTML: _vm._s(_vm.blockToOutput(block)) },
        })
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }